// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"feeb4a60","859":"0949c564","914":"4d4a0a70"}[chunkId] + ".chunk.js";
};